import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/goods/page', data, {
    trim: true
  })
}
export function allList (data) {
  return request.post('/business/goods/list', data, {
    trim: true
  })
}
export function detail (id) {
  return request.get(`/business/goods/${id}`)
}
// 创建
export function create (data) {
  return request.post('/business/goods/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/goods/updateById', data)
}
export function updateStatus (data) {
  return request.post('/business/goods/updateStatus', data)
}

export function findListByParentCategory (data) {
  return request.post('/business/goods/findListByParentCategory', data)
}
// 删除
export function deleteById (id) {
  return request.get(`/business/goods/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/goods/delete/batch', {
    params: {
      ids
    }
  })
}
